var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M19 5c1.094 0 2 .906 2 2v8c0 1.125-.906 2-2 2H3c-1.125 0-2-.875-2-2V7c0-1.094.875-2 2-2h16zm0 1H3c-.563 0-1 .469-1 1v8c0 .563.438 1 1 1h16c.531 0 1-.438 1-1V7c0-.531-.469-1-1-1z"}})}
var staticRenderFns = []

export { render, staticRenderFns }